import {
    SET_SETTINGS_DRAWER,
    SET_ERROR,
    SET_NOTIFICATIONS
} from '@/store/mutations.type'

export default {
    [SET_SETTINGS_DRAWER](state, flag) {
        state.userSettingsDrawer = flag
    },

    [SET_ERROR](state, error) {
        state.error = error
    },

    [SET_NOTIFICATIONS](state, message) {
        state.notification = message
    }

    // [UPDATE_ALL_USER_LIST](state, payload) {
    //     console.log(state)
    //     const userProfileFollower = state.profile.profileFollowers.find(user => user.id === payload.userId)
    //     if (userProfileFollower) Object.assign(userProfileFollower, payload.value)

    //     const userProfileFollowing = state.profile.profileFollowing.find(user => user.id === payload.userId)
    //     if (userProfileFollowing) Object.assign(userProfileFollower, payload.value)
    // }
}